import type {QRCopyResult} from '@Components/qr-code-generator/qr-generator-tracking.library';

export const UTM_COPIED_TOOLTIP_ID = 'utm-link-builder-copied-tooltip';

export interface UtmLinkPreviewProps {
  /** The link as typed so far; null while every field is empty. */
  previewLink: string | null;
  /** The same link once it is finished enough to copy; null until then. */
  completeLink: string | null;
  canClear: boolean;
  onClear: () => void;
  /** Once the clipboard has taken the link, or refused it. */
  onCopyResult: (copyResult: QRCopyResult) => void;
}
